import { Injectable } from '@angular/core';
import {Member} from '../models/member';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {FormGroup} from '@angular/forms';
import {AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask} from '@angular/fire/compat/storage';
import {finalize} from 'rxjs/operators';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';

@Injectable({
  providedIn: 'root'
})
export class Gn1Service {

  public objectImage: any = null; // store input file for avatar
  public storedImage: any; // store url image for local preview

  constructor(
    private db: AngularFirestore,
    private fs: AngularFireStorage,
    private snackBar: SnackBarIconService
    ) { }

  select () {
    return this.db.collection<any>('gn1_members', ref =>
      ref.orderBy('name', 'asc')).snapshotChanges();
  }

  insert (entity: Member) {
    delete entity.id;
    return this.db.collection('gn1_members').add(Object.assign({}, entity));
  }

  update (entity: Member) {
    let id = entity.id;
    delete entity.id;
    return this.db.collection('gn1_members').doc(id).set(Object.assign({}, entity), {merge: true});
  }

  delete(entity_id: any) {
    return this.db.collection('gn1_members').doc(entity_id).delete();
  }
  
  previewImage (event: any) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[ 0 ].type;
    if (mimeType.match(/image\/*/) == null) {
      this.snackBar.openSnackBar("Apenas arquivos .png", '', 'info');
      return;
    }

    var reader = new FileReader();
    this.objectImage = event.target.files[ 0 ];
    reader.readAsDataURL(event.target.files[ 0 ]);
    reader.onload = (_event) => {
      this.storedImage = reader.result;
      return event.target.files[ 0 ];
    }
  }

  uploadImage (file, entity_id, form: FormGroup) {
    const fsRef: AngularFireStorageReference = this.fs.ref("images/members/" + entity_id + ".png");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          this.updateImage(entity_id, url, form)
            .then((result) => {
              //  console.log("result: " + JSON.stringify(result))
              form.controls.image.setValue(result);
            })
        });
      }))
      .subscribe();
  }

  updateImage (entity_id: any, image: any, form: any) {
    return this.db.collection('gn1_members').doc(entity_id).set({image: image}, {merge: true})
      .then(() => {
        this.objectImage = ""
        return image;
      })
      .catch((err) => {
        console.log("erro upadate image: " + JSON.stringify(err))
      })
  }

  makeMsgError (errorsCode) {
    let msgError: string

    switch (errorsCode) {
      case "auth/email-already-exists":
        msgError = "Este email já está em uso"
        break;
      case "auth/phone-number-already-exists":
        msgError = "Este telefone já está em uso"
        break;
      case "auth/invalid-phone-number":
        msgError = "Telefone inválido. Muito longo"
        break;
      case "auth/invalid-password":
        msgError = "Senha deve conter, ao menos, 6 digitos"
        break;
    }

    return msgError
  }
  
}
